module.exports = __webpack_public_path__ + "img/telephone-forward-fill.080a54db.svg";